import { config, handleResponse } from '../../_helpers';

export const bookingChangesServices = {
    createRevision,                     // Create Revision Booking
    getBookingRef,                      // Get Booking For Revision
    getListBookingRevision,             // Get List Revision for Draft, For Approval, Approved, Denied, Canceled
    getRevisionId,                      // Get Specific Revion, View for Read
    getApprovedRevisionId,              // Get Revion that been approved for Read
    updateRevisionStatus,               // Update Revision Status, used for Canceled and Denied to Move to Draft
    updateRevisionId,                   // Updated Specific Revision
    deleteRevision,                     // Delete Unwanted Revision

    getListDat,
    getListApprover,
    AddRemoveSISHReference,
    InserNewSISHReference,
    generateSINum,

    downloadApproveBC,
}
function downloadApproveBC(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/downloadApprovedBC`, requestOptions).then(handleResponse);
}

function generateSINum() {
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/generateSINum`, requestOptions).then(handleResponse);
}
function AddRemoveSISHReference(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/AddRemoveSISHReference`, requestOptions).then(handleResponse);
}
function InserNewSISHReference(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/InserNewSISHReference`, requestOptions).then(handleResponse);
}
function getListDat(user, isDat, status, skip, take, myApproved, search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // if (search) {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListDat?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListDat?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/BookingRevisions/getListDatV1?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/BookingRevisions/getListDatV1?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}`, requestOptions).then(handleResponse);
    }
}
function getListApprover(user, status, skip, take, myApproved, accountingApprover, search) {
    const branch = user.branches.find(b => b.defaultBranch);
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListApprover?UserId=${user.userId}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}&isBCFinalApprover=${user.bcFinalApprover}&isAccountingApprover=${accountingApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListApprover?UserId=${user.userId}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&isBCFinalApprover=${user.bcFinalApprover}&isAccountingApprover=${accountingApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/BookingRevisions/getListApproverV1?UserId=${user.userId}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}&isBCFinalApprover=${user.bcFinalApprover}&isAccountingApprover=${accountingApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/BookingRevisions/getListApproverV1?UserId=${user.userId}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&isBCFinalApprover=${user.bcFinalApprover}&isAccountingApprover=${accountingApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    }
}
function createRevision(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/BookingRevisions/createRevision`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/BookingRevisions/createRevisionV1`, requestOptions).then(handleResponse);
}
function updateRevisionStatus(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    // return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatus`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatusV1`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatusV2`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatusV3`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatusV4`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionStatusV5`, requestOptions).then(handleResponse);
}
function updateRevisionId(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/updateRevisionId/${id}`, requestOptions).then(handleResponse);
}
function deleteRevision(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BookingRevisions/deleteRevision`, requestOptions).then(handleResponse);
}
function getBookingRef(bookingRef, userId, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // if (userId) {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getBookingRef/${bookingRef}?UserId=${userId}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getBookingRef/${bookingRef}`, requestOptions).then(handleResponse);
    // }
    if (userId) {
        return fetch(`${config.apiUrl}/BookingRevisions/getBookingRefV1/${bookingRef}?UserId=${userId}&userBranch=${branch}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/BookingRevisions/getBookingRefV1/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
    }

}
function getListBookingRevision(user, isDat, status, skip, take, myApproved, search, isAcctngApprover, isEndorser, endorserAdmin) {
    const branch = user.branches.find(b => b.defaultBranch);
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListBookingRevision?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}&isBCFinalApprover=${user.bcFinalApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/BookingRevisions/getListBookingRevision?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&isBCFinalApprover=${user.bcFinalApprover}&branch=${branch.branchCode}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/BookingRevisions/getListBookingRevisionV1?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&search=${search}&isBCFinalApprover=${user.bcFinalApprover}&branch=${branch.branchCode}&isAcctngApprover=${isAcctngApprover}&isEndorser=${isEndorser}&adminEndorser=${endorserAdmin}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/BookingRevisions/getListBookingRevisionV1?UserId=${user.userId}&isDat=${isDat}&status=${status}&skip=${skip}&take=${take}&showMyApproved=${myApproved}&isBCFinalApprover=${user.bcFinalApprover}&branch=${branch.branchCode}&isAcctngApprover=${isAcctngApprover}&isEndorser=${isEndorser}&adminEndorser=${endorserAdmin}`, requestOptions).then(handleResponse);
    }
}
function getRevisionId(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/BookingRevisions/getRevisionId/${id}`, requestOptions).then(handleResponse);
}
function getApprovedRevisionId(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/BookingRevisions/getApprovedRevisionId/${id}`, requestOptions).then(handleResponse);
}